<template>
  <a-tooltip>
    <template slot="title">
      {{message}}
    </template>
    <i class="ml-1 cursor-pointer text-muted fas fa-info-circle"></i>
  </a-tooltip>
</template>
<script>
  export default {
    props: {
      message: String
    }
  }
</script>
